import { createContext } from "react";

// Holds notifications data, fetching state, and a dismiss action for global access
export const NotificationsContext = createContext({
  notifications: [],
  isFetching: false,
  dismiss: () => {},
});
